<template>
  <div class="pricing-section">
    <SectionHeader
      v-if="showHeader"
      :title="title"
      :description="description"
      :rounded-top="hasRoundedHeader"
    >
      <slot name="header-content" />
    </SectionHeader>
    <div class="section-products">
      <ProductRow
        v-for="product in products"
        :key="product.id"
        :name="product.name"
        :discount-tag="product.discountTag"
        :original-price="product.originalPrice"
        :final-price="product.finalPrice"
      />
      <slot name="workspace-row" />
    </div>
    <SectionTotal
      :label="totalLabel"
      :amount="totalAmount"
    />
  </div>
</template>

<script>
import SectionHeader from './SectionHeader.vue';
import ProductRow from './ProductRow.vue';
import SectionTotal from './SectionTotal.vue';

export default {
  name: 'PricingSection',
  components: {
    SectionHeader,
    ProductRow,
    SectionTotal,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    products: {
      type: Array,
      required: true,
    },
    totalLabel: {
      type: String,
      required: true,
    },
    totalAmount: {
      type: String,
      required: true,
    },
    hasRoundedHeader: {
      type: Boolean,
      default: false,
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss">
@use './shared' as *;

.pricing-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.section-products {
  display: flex;
  flex-direction: column;
  padding-inline: 16px;
  gap: 8px;
}
</style>
